if (!window.Eurus.loadedScript.has('cart-term.js')) {
  window.Eurus.loadedScript.add('cart-term.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartTerm', (message) => ({
        message: message,
        checked: false,
        // OS-rettelse 02-10-2026: roed fejltekst foerst naar kunden har forsoegt at gaa til kassen
        tried: false,
        init() {
          // OS-rettelse 02-10-2026: feltet maa ikke vaere udfyldt paa forhaand, og
          // accepten skal gives hver gang der handles (Forbrugerombudsmandens Nettjek).
          // Temaet huskede 'agreed' i localStorage og satte fluebenet for returnerende
          // kunder. Starter nu altid tomt; selve accepten gemmes stadig paa ordren som
          // kurv-attributten 'Terms and conditions'.
          this.checked = false;

          this.$watch('checked', () => {
            this.save();
          });

          document.addEventListener('eurus:cart:validate', () => {
            // OS-rettelse 15-10-2026: kurvskuffen genindlaeses (fx naar gave-scripts laegger
            // gaver i), og hver gang oprettes en NY kopi af denne komponent. De gamle kopier
            // er fjernet fra siden, men deres lytter sad her stadig med checked=false og
            // blokerede 'Gaa til kassen' - selv naar kunden havde sat fluebenet i den synlige.
            // Kun den kopi der stadig er paa siden, maa stemme.
            if (!this.$el || !this.$el.isConnected) return;
            this.tried = true;
            if (!this.checked) Alpine.store('xCartHelper').validated = false;
          });
        },
        save() {
          clearTimeout(this.t);

          const func = () => {
            var status = this.checked ? 'agreed' : 'not agreed';
            Alpine.store('xCartHelper').updateCart({
              attributes: {
                'Terms and conditions': status
              }
            });
            localStorage.cart_term_checked = status;
          }
          
          this.t = setTimeout(() => {
            func();
          }, 200);
        }
      }));
    })
  });
};